import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Countries } from '../models/settings/countries.model';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient) { }

  public getCountries(): Observable<Countries> {
    return this.http.get<Countries>(`${this.appConfigService.getConfig().apiUrl}country`);
  }
}
